import { render, staticRenderFns } from "./home.vue?vue&type=template&id=19023b34"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19023b34')) {
      api.createRecord('19023b34', component.options)
    } else {
      api.reload('19023b34', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=19023b34", function () {
      api.rerender('19023b34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/home.vue"
export default component.exports